//Add Subvendor Modal
export const subVendorDialogData = [
  {
    placeholder: "Name",
    required: true,
    type: "text",
    name: "name",
    label: "Sub-Vendor Name",
    star: "*",
    countrycode: false,
  },
  {
    placeholder: "Mobile Number",
    required: true,
    type: "text",
    name: "number",
    label: "Mobile Number",
    star: "*",
    countrycode: true,
  },
  {
    placeholder: "Email",
    required: true,
    star: "*",
    type: "text",
    name: "email",
    label: "Email ID",
    countrycode: false,
  },
  {
    placeholder: "Name",
    required: false,
    type: "text",
    name: "vendorName",
    label: "City Manager",
    star: "*",
    countrycode: false,
    disabled: true,
  },
];

//Edit Subvendor Modal
export const editSubVendorDialogData = (details) => [
  {
    placeholder: "Name",
    required: true,
    type: "text",
    name: "name",
    label: "Sub-Vendor Name",
    countrycode: false,
    defaultValue: details?.companyName || "",
  },
  {
    placeholder: "Mobile Number",
    required: true,
    type: "text",
    name: "number",
    label: "Mobile Number",
    countrycode: true,
    defaultValue: details?.mobile?.replaceAll("+91", "") || "",
  },
  {
    placeholder: "Email",
    required: true,
    type: "text",
    name: "email",
    label: "Email",
    countrycode: false,
    defaultValue: details?.email || "",
  },
];

// <---- SubVendor Driver Data ------>
//Add Subvendor Modal
export const subVendorDriverDialogData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'driverName',
    label: 'Driver Name',
    star: '*',
    countrycode: false,
  },
  
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email ID',
    countrycode: false,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    star: '*',
    countrycode: false,
    disabled: true,
  },
  {
    placeholder: "Name",
    required: false,
    type: "text",
    name: "vendorName",
    label: "Sub-Vendor Name",
    star: "*",
    countrycode: false,
    disabled: true,
  },
];